import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Pencil, Trash2 } from "lucide-react";

/** Drag-sortable wrapper around a single category pill. */
export default function SortableCategory({ cat, active, editing, onSelect, onEdit, onDelete }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: cat.id,
    disabled: !editing,
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };
  return (
    <div ref={setNodeRef} style={style} className="relative shrink-0" data-testid={`sortable-cat-${cat.id}`}>
      <button
        type="button"
        onClick={() => onSelect(cat.id)}
        className={`cat-pill ${active ? "active" : ""}`}
        data-testid={`category-${cat.id}`}
      >
        {editing && (
          <span
            {...attributes}
            {...listeners}
            className="cursor-grab active:cursor-grabbing touch-none -ml-1"
            onClick={(e) => e.stopPropagation()}
            aria-label="Drag to reorder"
            data-testid={`drag-handle-cat-${cat.id}`}
          >
            <GripVertical size={16} />
          </span>
        )}
        <span className="swatch" style={{ background: cat.color }} />
        <span className="text-xl leading-none" aria-hidden>{cat.emoji}</span>
        <span className="flex-1 truncate">{cat.name}</span>
      </button>
      {editing && (
        <div className="absolute -top-2 -right-2 flex gap-1">
          <button
            type="button"
            className="bg-[color:var(--gold)] border-[3px] border-[color:var(--ink)] rounded-full w-7 h-7 flex items-center justify-center shadow-[2px_2px_0_0_var(--ink)]"
            onClick={() => onEdit(cat)}
            aria-label="Edit category"
            data-testid={`category-edit-${cat.id}`}
          >
            <Pencil size={12} />
          </button>
          <button
            type="button"
            className="bg-[color:var(--coral)] text-white border-[3px] border-[color:var(--ink)] rounded-full w-7 h-7 flex items-center justify-center shadow-[2px_2px_0_0_var(--ink)]"
            onClick={() => onDelete(cat)}
            aria-label="Delete category"
            data-testid={`category-delete-${cat.id}`}
          >
            <Trash2 size={12} />
          </button>
        </div>
      )}
    </div>
  );
}
